export default __webpack_public_path__ + "static/media/ic-irr-set.64fc09c1.svg";